import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { WrapMeWith } from "@/common/components/wrap-me-with/wrap-me-with";

import { BindingOfferDialog } from "./binding-offer-dialog";
import { formatTradingHoursWithFallback } from "./format-trading-hours";

type BindingOfferMarketplaceOrderDialogProps = {
  traderName: string;
  cropName: string;
  amount: string;
  quarter: string;
  postalCodeLabel: string;
  parameters?: string;
  unitPrice: string;
  tocUrl: string | null;
  timeFromTrading: string | null;
  timeToTrading: string | null;
  isPending: boolean;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferMarketplaceOrderDialog = ({
  postalCodeLabel,
  tocUrl,
  timeFromTrading,
  timeToTrading,
  ...props
}: BindingOfferMarketplaceOrderDialogProps) => {
  const tradingHours = formatTradingHoursWithFallback(
    timeFromTrading,
    timeToTrading,
  );

  return (
    <BindingOfferDialog
      {...props}
      confirmLabel={<Trans>Odeslat poptávku</Trans>}
      introText={
        <Trans>
          Kupující tímto předkládá prodávajícímu závazný požadavek na nákup
          zboží za níže uvedených podmínek:
        </Trans>
      }
      legalConsentText={
        <Trans>
          Kupující potvrzením tohoto požadavku vyjadřuje souhlas s uvedenými
          podmínkami a s tím, že obsah kupní smlouvy se bude řídit{" "}
          <WrapMeWith
            when={!!tocUrl}
            wrapper={(children) => (
              <a
                className="text-can-forest-teal underline"
                href={tocUrl!}
                rel="noreferrer"
                target="_blank"
              >
                {children}
              </a>
            )}
          >
            obchodními podmínkami
          </WrapMeWith>{" "}
          prodávajícího.
        </Trans>
      }
      legalNoticeText={
        <Trans>
          Kupující bere na vědomí, že prodávající nemá povinnost tento návrh
          akceptovat. Kupní smlouva vzniká konfirmací tohoto závazného návrhu ze
          strany prodávajícího.
        </Trans>
      }
      parity={t`CPT - ${postalCodeLabel}`}
      title={<Trans>Podmínky pro vytvoření závazné poptávky</Trans>}
      traderLabel={t`Prodávající`}
      tradingHoursText={
        <Trans>
          Prodávající přijímá závazné objednávky v obchodních hodinách mezi{" "}
          {tradingHours} hod SEČ.
        </Trans>
      }
    />
  );
};

export { BindingOfferMarketplaceOrderDialog };
